export default "<div class=\"search-box\">\n  <input type=\"text\" placeholder=\"Search\" #input />\n  <fa-icon [icon]=\"faSearch\"></fa-icon>\n</div>\n"